import React, { useState } from "react";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import './Disparo.css';

const HEADER_HEIGHT = 56;

const Disparo = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 - por cima do header */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
              ? 220
              : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
              ? 220
              : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
              ? 220
              : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (

            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} /></a>

          ) : (

            <a href="/app">
            <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} /></a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanhas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Projetos" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-folder2-open" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Meus Projetos</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Contas" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-send" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Disparo 1x1</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-robot" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Disparo 1x1</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "6px 16px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <a className="dropdown-item" href="#">Perfil</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">Configurações</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de campanha */}
      <div style={{
        marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
        paddingTop: HEADER_HEIGHT,
        width: window.innerWidth > 768
          ? sidebarOpen
            ? "calc(100% - 220px)"
            : "calc(100% - 70px)"
          : "100vw",
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
      }}>
        {/* Conteúdo da página de campanha */}
      </div>
    </div>
  );
};

export default Disparo;